export { SITE_URL, SITE_NAME } from "./seo";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/suriwebwinkel/id1573691847";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=nl.suriwebwinkel.suriwebdev";
export const WHATSAPP_URL = "https://wa.me/31637060001";
export const EMAIL = "suriweb@suriwebwinkel.nl";
export const PHONE_NL = "+31 6 3706 0001";
export const SATYAM_HOLIDAYS_URL = "https://www.satyamtours.nl";
export const SATYAM_HOLIDAYS_NAME = "Satyam Holidays";
export const SATYAM_HOLIDAYS_LABEL = "Een merk van";

export const NAV_LINKS = [
  { to: "/", label: "Home", exact: true },
  { to: "/producten", label: "Producten" },
  { to: "/pakketten", label: "Pakketten" },
  { to: "/hoe-het-werkt", label: "Hoe het werkt" },
  { to: "/waarom", label: "Waarom wij" },
  { to: "/contact", label: "Contact" },
  { to: "/terms", label: "Voorwaarden" },
];
